export default "__VITE_ASSET__b7c10733__"